import { useMutation } from "react-query";
import { updateOffice } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useEditOfficeSettings = () => {
  return useMutation(updateOffice);
};
export default useEditOfficeSettings;
